import React from "react";
import { TCText } from "../TCText/TCText";
import { usePaymentStore } from "../../stores/StoreContext";
import { PaymentCard } from "./PaymentCard";
import { observer } from "mobx-react-lite";
import cross from "../../assets/cross.png";

type props = {
  visible: boolean;
};

export const ChangeDefaultCardModal: React.FC<props> = observer(
  ({ visible }) => {
    const paymentStore = usePaymentStore();

    return visible ? (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
        }}>
        <div
          style={{
            backgroundColor: "white",
            borderRadius: 16,
            padding: "20px 20px 0",
            display: "flex",
            flexDirection: "column",
            width: "90%",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            maxHeight: "50vh",
            paddingBottom: 20,
            maxWidth: "450px",
          }}>
          <img
            onClick={
              paymentStore.isPaymentCardLoading
                ? undefined
                : () => (paymentStore.isChangePaymentMethodModalVisible = false)
            }
            src={cross}
            alt=""
            style={{ height: 15, width: 15, alignSelf: "flex-end" }}
          />
          <TCText
            style={{
              fontWeight: 600,
              fontSize: 16,
              color: "black",
              textAlign: "center",
              marginBottom: 20,
            }}
            value={"Change default card"}
          />
          <div
            style={{
              overflowY: "auto",
              flex: 1,
              paddingBottom: 20,
            }}>
            {paymentStore.paymentCards.map((card) => (
              <PaymentCard card={card} />
            ))}
          </div>
        </div>
      </div>
    ) : null;
  }
);
